import { Injectable } from '@angular/core'

import { StoreService } from '@core/store.service'

@Injectable()
export class UserService {
   console: boolean = true
   logPrefix: string = '@core - ' + this.constructor.name

   public type: string
   public roles: string[]

   constructor(public store: StoreService) {
      this.clearUser()
   }

   clearUser() {
      this.clearType()
      this.clearRoles()
      this.clearData()
   }

   getType() {
      return this.type
   }

   setType(type: string) {
      if (type != null) {
         this.type = type
         return true
      }
      return false
   }

   clearType() {
      return this.setType('')
   }

   getRoles() {
      return this.roles
   }

   setRoles(roles: string[]) {
      if (roles && roles.length) {
         this.roles = roles
         return true
      }
      return false
   }

   addRoles(roles: string[]) {
      if (roles && roles.length) {
         for (let role of roles) {
            this.roles.push(role.trim())
         }
         return true
      }
      return false
   }

   clearRoles() {
      this.roles = []
      return true
   }

   public hasRole(role: string): boolean {
      return role && this.roles.includes(role)
   }

   public hasRoles(roles: string[]): boolean {
      if (roles && roles.length) {
         for (let role of roles) {
            if (this.hasRole(role)) return true
         }
      }

      return false
   }

   public hasAllRoles(roles: string[]): boolean {
      if (roles && roles.length) {
         let count = 0

         for (let role of roles) {
            if (this.hasRole(role)) count++
         }

         if (count == roles.length) return true
      }

      return false
   }

   //-- UserData --//

   setData(data: any) {
      if (typeof data == 'object') {
         var storeReply = this.store.setData('UserData', data)
         return !storeReply.error // confirm
      }

      return false
   }

   getData() {
      var storeReply = this.store.getData('UserData')
      return !storeReply.error ? storeReply.result : null
   }

   clearData() {
      var storeReply = this.store.setData('UserData', {})
      return !storeReply.error // confirm
   }

   getDataParam(param: string) {
      if (param) {
         const userData = this.getData()
         if (userData && userData.hasOwnProperty(param)) {
            return userData[param]
         }
      }
      return null
   }

   getId() {
      const userData = this.getData()
      if (userData && userData.hasOwnProperty('id')) {
         return userData['id']
      }
      return null
   }
}

